import $ from 'jquery';
import isTouchDevice from "./helpers/isTouchDevice";

const wideMenuImageControls = () => {
    if (document.querySelector('.ume-wide-menu-wrapper')) {
        if ($(window).width() >= 1199 && !isTouchDevice) {
            const wrappers = document.querySelectorAll('.ume-wide-menu-wrapper');
            wrappers.forEach(wrapper => {
                const image = wrapper.querySelector('.ume-wide-inner-active-image');
                const caption = wrapper.querySelector('.ume-wide-inner-active-image--caption');
                let defaultText = caption.innerHTML;
                let defaultImageUrl = image.src;
                const links = wrapper.querySelectorAll('.ume-nav-link-with-preview');
                links.forEach(link => {
                    if (link.classList.contains('active')) {
                        let newImage = link.getAttribute('data-preview-image');
                        let newText = link.getAttribute('data-preview-text');
                        image.src = newImage;
                        caption.innerHTML = newText;
                        defaultImageUrl = newImage;
                        defaultText = newText;
                    }
                })

                wrapper.addEventListener('mouseover', ev => {
                    if (!ev.target.matches('.ume-nav-link-with-preview')) {
                        image.src = defaultImageUrl;
                        caption.innerHTML = defaultText;


                        return;
                    }
                    let link = ev.target;
                    let newImage = link.getAttribute('data-preview-image');
                    let newText = link.getAttribute('data-preview-text');
                    //console.log(newImage, 'newImage');
                    image.src = newImage;
                    caption.innerHTML = newText;
                })
            })
        }
    }
}
export default wideMenuImageControls;